module.exports = __webpack_public_path__ + "img/gill3.71b12598.svg";